/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoAppRemoveRequest model module.
 * @module model/CampaignControllerDtoAppRemoveRequest
 * @version 1.0
 */
class CampaignControllerDtoAppRemoveRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoAppRemoveRequest</code>.
     * @alias module:model/CampaignControllerDtoAppRemoveRequest
     * @param appNo {Array.<Number>} 
     */
    constructor(appNo) { 
        
        CampaignControllerDtoAppRemoveRequest.initialize(this, appNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, appNo) { 
        obj['appNo'] = appNo;
    }

    /**
     * Constructs a <code>CampaignControllerDtoAppRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoAppRemoveRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoAppRemoveRequest} The populated <code>CampaignControllerDtoAppRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoAppRemoveRequest();

            if (data.hasOwnProperty('appNo')) {
                obj['appNo'] = ApiClient.convertToType(data['appNo'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoAppRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoAppRemoveRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoAppRemoveRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is an array
        if (!Array.isArray(data['appNo'])) {
            throw new Error("Expected the field `appNo` to be an array in the JSON data but got " + data['appNo']);
        }

        return true;
    }


}

CampaignControllerDtoAppRemoveRequest.RequiredProperties = ["appNo"];

/**
 * @member {Array.<Number>} appNo
 */
CampaignControllerDtoAppRemoveRequest.prototype['appNo'] = undefined;






export default CampaignControllerDtoAppRemoveRequest;

